/**
 * Org-scoped client stores register a reset here, and the session store runs them all
 * on logout or a sign-in to a different org. Zustand stores outlive storage.clear()
 * across SPA navigation, so without this the next user would see the previous org's
 * data. This is a leaf module so a store can register without importing the session
 * hook, which would close an import cycle through utils/storageUtils.
 */
type SessionReset = () => void;

const sessionResets = new Set<SessionReset>();

export const registerSessionReset = (reset: SessionReset): void => {
  sessionResets.add(reset);
};

export const resetSessionScopedStores = (): void => {
  const failures: unknown[] = [];
  sessionResets.forEach((reset) => {
    try {
      reset();
    } catch (error) {
      // Finish clearing the other stores, but never authorize a new session
      // while even one store may still hold the previous organization's data.
      failures.push(error);
    }
  });
  if (failures.length > 0) {
    throw new AggregateError(
      failures,
      'Session-scoped stores could not be reset'
    );
  }
};
